export default __webpack_public_path__ + "static/media/segundologincaptcha.ba776eab.svg";